import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "offset-y": "",
    location: "bottom"
  }, {
    activator: _withCtx(({ props, isActive }) => [
      _createVNode(_component_v_btn, _mergeProps({ color: "secondary" }, props, {
        elevation: "0",
        rounded: "sm",
        class: "ml-1 px-1",
        variant: "plain",
        size: "small"
      }), {
        default: _withCtx(() => [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                class: "mr-2",
                size: "small",
                icon: _ctx.icon
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_v_icon, {
            class: "ml-2",
            size: "x-small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isActive ? "$fa-angle-down" : "$fa-angle-up"), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}